/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_InvoiceInputs */

const cs_enum_invoice = /** @type {(inputs: Enum_InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faktura`)
};

const en_enum_invoice = /** @type {(inputs: Enum_InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invoice`)
};

/**
* | output |
* | --- |
* | "Invoice" |
*
* @param {Enum_InvoiceInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_invoice = /** @type {((inputs?: Enum_InvoiceInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_InvoiceInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_invoice(inputs)
	return cs_enum_invoice(inputs)
});